import React from 'react'
import { Arrow, Circle } from 'react-konva'
import { toScale } from '../../../lib/canvas-math.js'

const STROKE = '#5BA3D0'
const FILL = '#2E7DB8'

/**
 * Uçak rotası: çizgi üzerinde belirgin ok(lar) ile yön gösterilir.
 */
const PlanePath = ({ planePath, pubgMapSize, mapSize, mapScale }) => {
    if (!planePath || !planePath.start || !planePath.stop) return null

    const { start, stop } = planePath
    const x1 = toScale(pubgMapSize, mapSize, start.x)
    const y1 = toScale(pubgMapSize, mapSize, start.y)
    const x2 = toScale(pubgMapSize, mapSize, stop.x)
    const y2 = toScale(pubgMapSize, mapSize, stop.y)

    const dx = x2 - x1
    const dy = y2 - y1
    const len = Math.sqrt(dx * dx + dy * dy)
    const ux = len > 0 ? dx / len : 0
    const uy = len > 0 ? dy / len : 0

    const strokeW = Math.max(2.5, 4 / mapScale)
    const endPointerLen = Math.max(28, 60 / mapScale)
    const endPointerW = Math.max(24, 50 / mapScale)
    const startRadius = Math.max(6, 14 / mapScale)

    const mx = (x1 + x2) / 2
    const my = (y1 + y2) / 2
    const segHalf = Math.max(35, 70 / mapScale)
    const midArrowLen = Math.max(22, 45 / mapScale)
    const midArrowW = Math.max(18, 36 / mapScale)

    return (
        <React.Fragment>
            <Circle
                x={x1}
                y={y1}
                radius={startRadius}
                fill={FILL}
                stroke={STROKE}
                strokeWidth={strokeW}
                listening={false}
            />
            <Arrow
                points={[
                    mx - segHalf * ux, my - segHalf * uy,
                    mx + segHalf * ux, my + segHalf * uy,
                ]}
                stroke={STROKE}
                fill={FILL}
                strokeWidth={strokeW}
                pointerLength={midArrowLen}
                pointerWidth={midArrowW}
                listening={false}
            />
            <Arrow
                points={[x1, y1, x2, y2]}
                stroke={STROKE}
                fill={FILL}
                strokeWidth={strokeW}
                pointerLength={endPointerLen}
                pointerWidth={endPointerW}
                listening={false}
            />
        </React.Fragment>
    )
}

export default PlanePath



// WEBPACK FOOTER //
// ./src/components/MatchPlayer/Map/PlanePath.js